export function radioDefaultToApply(
  currentValue: unknown,
  selectedOption: string | undefined,
  optionValues: readonly string[],
  forced = false): string | undefined {
  if (forced) {
    return selectedOption;
  }
  if (typeof currentValue === 'string' && optionValues.includes(currentValue)) {
    return undefined;
  }
  return selectedOption;
}
